import { NumericalInput } from "./NumericalInput";

export default NumericalInput;
